/* ==========================================================================
   PurrfectSoles theme.js — vanilla, no dependencies.
   Purchasing never depends on JS: AJAX is progressive enhancement only.
   ========================================================================== */
(function () {
  'use strict';

  var PS = window.PS || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = PS.moneyFormat || '${{amount}}';
    if (fmt.indexOf('amount_no_decimals') > -1) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Sticky header shadow ---------- */
  function initStickyHeader() {
    var header = $('.ps-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = $('.ps-mobile-menu');
    var openBtn = $('[data-menu-open]');
    var closeBtn = $('[data-menu-close]');
    if (!menu || !openBtn) return;

    var open = function () { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { menu.classList.remove('is-open'); document.body.style.overflow = ''; };

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.addEventListener('click', function (e) { if (e.target === menu) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity(ctx) {
    $all('[data-qty]', ctx).forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $all('[data-qty-btn]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-qty-btn') === 'up' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var val = parseInt(input.value || '1', 10) + step;
          if (isNaN(val) || val < min) val = min;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Accordions (FAQ + product tabs) ---------- */
  function initAccordions(ctx) {
    $all('[data-accordion-toggle]', ctx).forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        panel.style.maxHeight = isOpen ? null : panel.scrollHeight + 'px';
      });
    });
  }

  /* ---------- Product form (gallery, variants, AJAX add) ---------- */
  function initProductForm(root) {
    var form = $('[data-product-form]', root);
    if (!form) return;

    var dataEl = $('[data-product-json]', root);
    var productData = null;
    try { productData = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { productData = null; }

    var idInput = $('[data-variant-id]', form);
    var priceWrap = $('[data-price]', root);
    var addBtn = $('[data-add-btn]', form);

    /* Gallery thumbnails */
    var mainImg = $('[data-gallery-main] img', root);
    $all('[data-gallery-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) { mainImg.src = src; }
        $all('[data-gallery-thumb]', root).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    function selectedOptions() {
      var opts = [];
      $all('[data-option-index]', form).forEach(function (group) {
        var checked = $('input:checked', group) || $('select', group);
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      if (!productData || !productData.variants) return null;
      // Default-variant products have no option pickers — use the only variant.
      if (productData.variants.length === 1) return productData.variants[0];
      return productData.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    function updateVariant() {
      if (!productData) return;
      var variant = findVariant(selectedOptions());

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      // Swap the main gallery image to the selected variant's photo
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image;
        var vBase = variant.featured_image.split('?')[0];
        $all('[data-gallery-thumb]', root).forEach(function (t) {
          var tBase = (t.getAttribute('data-full') || '').split('?')[0];
          t.classList.toggle('is-active', tBase === vBase);
        });
      }

      if (priceWrap) {
        var current = $('[data-price-current]', priceWrap);
        var compare = $('[data-price-compare]', priceWrap);
        if (current) current.textContent = formatMoney(variant.price);
        if (compare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.textContent = formatMoney(variant.compare_at_price);
            compare.hidden = false;
            priceWrap.classList.add('ps-price--on-sale');
          } else {
            compare.hidden = true;
            priceWrap.classList.remove('ps-price--on-sale');
          }
        }
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add-label') || 'Add to Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        }
      }

      // Sync sticky bar price
      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      // URL update for shareability
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $all('[data-option-index] input, [data-option-index] select', form).forEach(function (el) {
      el.addEventListener('change', updateVariant);
    });

    /* AJAX add to cart (graceful fallback to native submit) */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !PS.routes || !PS.routes.cartAdd) return; // native submit
      e.preventDefault();
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

      fetch(PS.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: idInput ? idInput.value : null,
          quantity: parseInt(($('[data-qty] input', form) || {}).value || '1', 10)
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refreshCartCount(); })
        .then(function () {
          if (addBtn) { addBtn.textContent = 'Added ✓'; }
          setTimeout(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-add-label') || 'Add to Cart'; }
          }, 1400);
        })
        .catch(function () { form.submit(); }); // fall back to normal submission
    });

    updateVariant();
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    if (!window.fetch) return Promise.resolve();
    return fetch(PS.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $all('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Free shipping progress ---------- */
  function initShipProgress() {
    var bars = $all('[data-ship-progress]');
    if (!bars.length) return;
    var threshold = (PS.shippingThreshold || 0) * 100;

    fetch(PS.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bars.forEach(function (bar) {
          var fill = $('[data-ship-fill]', bar);
          var text = $('[data-ship-text]', bar);
          if (threshold <= 0) { bar.style.display = 'none'; return; }
          var pct = Math.min(100, (cart.total_price / threshold) * 100);
          if (fill) fill.style.width = pct + '%';
          if (text) {
            if (cart.total_price >= threshold) {
              text.textContent = "🎉 You've unlocked free shipping!";
            } else {
              text.textContent = 'You\'re ' + formatMoney(threshold - cart.total_price) + ' away from free shipping';
            }
          }
        });
      })
      .catch(function () {});
  }

  /* ---------- Sticky mobile add-to-cart ---------- */
  function initStickyAtc() {
    var sticky = $('.ps-sticky-atc');
    var anchor = $('[data-sticky-anchor]');
    if (!sticky || !anchor) return;

    var addBtn = $('[data-sticky-add]', sticky);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var form = $('[data-product-form]');
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show sticky once the main CTA has scrolled out of view (upward)
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', scrolledPast);
        });
      }, { threshold: 0 });
      observer.observe(anchor);
    }
  }

  /* ---------- Newsletter / contact success scroll ---------- */
  function initFormSuccess() {
    var success = $('[data-form-success]');
    if (success) { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initMobileMenu();
    initQuantity();
    initAccordions();
    $all('[data-product-root]').forEach(initProductForm);
    refreshCartCount();
    initShipProgress();
    initStickyAtc();
    initFormSuccess();
  });

  /* ---------- Theme editor support ----------
     When a section is re-rendered in the Shopify theme editor, re-bind its
     listeners (otherwise variant pickers, quantity, accordions go dead). */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    initQuantity(section);
    initAccordions(section);
    var root = section.querySelector('[data-product-root]');
    if (root) initProductForm(root);
    initStickyAtc();
    initShipProgress();
  });
})();
